// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulsePrimary {
  0% {
    box-shadow: 0 0 0 0 rgba(109, 138, 250, 0.4);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(109, 138, 250, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(109, 138, 250, 0);
  }
}
@keyframes pulseSecondary {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
.custom-button {
  padding: 1.45rem 2.4rem;
  background: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);
  font-size: 1.4rem;
  font-weight: 500;
  color: #ffffff;
  border: 0;
  border-radius: 1rem;
  transition: all ease-in-out 0.25s;
}
@media (max-width: 767px) {
  .custom-button {
    padding: 1.2rem 1.8rem;
    font-size: 1.2rem;
  }
}
.custom-button.pulse {
  animation: pulsePrimary 1s forwards ease-out;
  box-shadow: 0px 15px 28px -11px rgba(109, 138, 250, 0.9);
}
.custom-button:hover:not(:disabled) {
  box-shadow: rgba(255, 255, 255, 0.1) 0px 8px 16px;
}
.custom-button.secondary-btn {
  border-color: #ffffff;
  background-color: #ffffff;
  color: #000000;
}
.custom-button.secondary-btn:hover:not(:disabled) {
  color: #ffffff;
  background-color: transparent;
}
.custom-button.outline-btn {
  color: #6d8afa;
  background: transparent;
  border: 0.1rem solid #6d8afa;
  padding: 1.35rem 2.4rem;
}
@media (max-width: 767px) {
  .custom-button.outline-btn {
    padding: 1.1rem 1.8rem;
  }
}
.custom-button.outline-btn:hover:not(:disabled) {
  color: #ffffff;
  background: #6d8afa;
}
.custom-button.secondary-btn.pulse, .custom-button.outline-btn.pulse {
  animation: pulseSecondary 1s forwards ease-out;
  box-shadow: 0px 15px 28px -11px rgba(255, 255, 255, 0.9);
}
.custom-button:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}
.custom-button--icon {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
}
.custom-button--icon .btn-icon {
  flex-shrink: 0;
  margin-left: 2.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  width: 4rem;
  height: 4rem;
  background-color: #6f86de;
}
@media (max-width: 767px) {
  .custom-button--icon .btn-icon {
    margin-left: 1.5rem;
    width: 3rem;
    height: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/UI/CustomButton/CustomButton.scss","webpack://./src/Assets/Theme/_var.scss"],"names":[],"mappings":"AAEA;EACE;IAEE,4CAAA;EAAF;EAEA;IAEE,6CAAA;EAAF;EAEA;IAEE,0CAAA;EAAF;AACF;AAGA;EACE;IAEE,4CAAA;EADF;EAGA;IAEE,6CAAA;EADF;EAGA;IAEE,0CAAA;EADF;AACF;AAIA;EACE,uBAAA;EACA,mEAAA;EACA,iBAAA;EACA,gBAAA;EACA,cChCM;EDiCN,SAAA;EACA,mBAAA;EACA,iCAAA;AAFF;AAIE;EAVF;IAWI,sBAAA;IACA,iBAAA;EADF;AACF;AAGE;EACE,4CAAA;EACA,wDAAA;AADJ;AAIE;EACE,iDAAA;AAFJ;AAKE;EACE,qBCpDI;EDqDJ,yBCrDI;EDsDJ,cCrDI;ADkDR;AAKI;EACE,cCzDE;ED0DF,6BAAA;AAHN;AAOE;EACE,cC7DM;ED8DN,uBAAA;EACA,4BAAA;EACA,uBAAA;AALJ;AAOI;EANF;IAOI,sBAAA;EAJJ;AACF;AAMI;EACE,cCzEE;ED0EF,mBCxEI;ADoEV;AAUI;EACE,8CAAA;EACA,wDAAA;AARN;AAYE;EACE,aAAA;EACA,mBAAA;AAVJ;AAaE;EACE,oBAAA;EACA,mBAAA;EACA,oCAAA;AAXJ;AAYI;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBCrGK;AD2FX;AAYM;EAXF;IAYI,mBAAA;IACA,WAAA;IACA,YAAA;EATN;AACF","sourcesContent":["@import \"../../../Assets/Theme/_var.scss\";\n\n@keyframes pulsePrimary {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba($primary, 0.4);\n    box-shadow: 0 0 0 0 rgba($primary, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 15px rgba($primary, 0);\n    box-shadow: 0 0 0 15px rgba($primary, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba($primary, 0);\n    box-shadow: 0 0 0 0 rgba($primary, 0);\n  }\n}\n\n@keyframes pulseSecondary {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba($white, 0.4);\n    box-shadow: 0 0 0 0 rgba($white, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 15px rgba($white, 0);\n    box-shadow: 0 0 0 15px rgba($white, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba($white, 0);\n    box-shadow: 0 0 0 0 rgba($white, 0);\n  }\n}\n\n.custom-button {\n  padding: 1.45rem 2.4rem;\n  background: $gradient;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: $white;\n  border: 0;\n  border-radius: 1rem;\n  transition: all ease-in-out 0.25s;\n\n  @media (max-width: 767px) {\n    padding: 1.2rem 1.8rem;\n    font-size: 1.2rem;\n  }\n\n  &.pulse {\n    animation: pulsePrimary 1s forwards ease-out;\n    box-shadow: 0px 15px 28px -11px rgba($primary, 0.9);\n  }\n\n  &:hover:not(:disabled) {\n    box-shadow: rgba(255, 255, 255, 0.1) 0px 8px 16px;\n  }\n\n  &.secondary-btn {\n    border-color: $white;\n    background-color: $white;\n    color: $black;\n\n    &:hover:not(:disabled) {\n      color: $white;\n      background-color: transparent;\n    }\n  }\n\n  &.outline-btn {\n    color: $primary;\n    background: transparent;\n    border: 0.1rem solid $primary;\n    padding: 1.35rem 2.4rem;\n\n    @media (max-width: 767px) {\n      padding: 1.1rem 1.8rem;\n    }\n\n    &:hover:not(:disabled) {\n      color: $white;\n      background: $primary;\n    }\n  }\n\n  &.secondary-btn,\n  &.outline-btn {\n    &.pulse {\n      animation: pulseSecondary 1s forwards ease-out;\n      box-shadow: 0px 15px 28px -11px rgba($white, 0.9);\n    }\n  }\n\n  &:disabled {\n    opacity: 0.75;\n    cursor: not-allowed;\n  }\n\n  &--icon {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.5rem 0.5rem 0.5rem 1.5rem;\n    .btn-icon {\n      flex-shrink: 0;\n      margin-left: 2.4rem;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 0.5rem;\n      width: 4rem;\n      height: 4rem;\n      background-color: $primary2;\n\n      @media (max-width: 767px) {\n        margin-left: 1.5rem;\n        width: 3rem;\n        height: 3rem;\n      }\n    }\n  }\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$baseFont: \"Poppins\", sans-serif;\n$baseFont2: \"Krona One\", sans-serif;\n\n$white: #ffffff;\n$black: #000000;\n$primary: #6d8afa;\n$primary2: #6f86de;\n$lightGray: #bdbdbd;\n$lightGray2: #d1d1d1;\n$secondary: #252a3a;\n$secondary2: #232323;\n$secondary3: #a3a3a3;\n$secondary4: #727272;\n$secondary5: #292c2e;\n$secondarybg: #171b27;\n$secondarybg2: #22283a;\n$secondarybg3: #202535;\n$secondarybg4: #172545;\n$borderClr: #262626;\n$borderClr2: #252525;\n$borderClr3: #28343e;\n\n$green: #7bbb3f;\n$blue: #2797d1;\n$red: #c3292d;\n$orange: #f68630;\n$skyblue: #01cde4;\n$yellowdark: #fbbb10;\n$reddark: #e54c40;\n\n$btnGradient: linear-gradient(270deg, #fde679 -0.16%, #f26c33 86.5%);\n\n$gradient: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);\n$gradient2: linear-gradient(0deg, rgba(0, 0, 0, 0) -29.92%, #161616 97.38%);\n$gradient3: linear-gradient(90deg, #fde076 1.57%, rgba(242, 107, 51, 0) 101.1%);\n$gradient4: linear-gradient(261.01deg, #212122 2.84%, rgba(0, 0, 0, 0) 165.67%);\n\n$boxShadow: 0 1.2rem 1.6rem -0.4rem rgba(255, 255, 255, 0.2),\n  0 0.4rem 0.6rem -0.2rem rgba(255, 255, 255, 0.15);\n$boxShadow2: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);\n$boxShadow3: inset 3px 17px 37px rgba(3, 3, 3, 0.6),\n  inset 0px 0px 5px rgba(255, 255, 255, 0.1);\n\n// z indexes\n$header: 988;\n$sidebar: $header + 3;\n$sidebar_overlay: $sidebar - 2;\n$modal: 1056;\n$loader: 1090;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
